export default __webpack_public_path__ + "static/media/scrapepic.d9975e27.png";